import constructActionTypes from 'common/utils/constructActionTypes';

module.exports = constructActionTypes(
    {
        UPDATE_FORM_NODE: null,
        UPDATE_FORM_NODE_CANCEL_PREVIOUS: null,
        RESET_FORM: null,
        START_SUBMISSION: null,
        VALIDATE_ERRORS_AND_START_SUBMISSION: null,
        VALIDATE_TICKET_SUBMISSION: null,
        VALIDATE_SUBMISSION: null,
        SUBMIT_SUBMISSION: null,
        MOBILE_RSVP_SUBMISSION: null,
        FETCH_SUBMISSION: null,
        SUCCESS_REQUEST_SUBMISSION: null,
        FAILED_REQUEST_SUBMISSION: null,
        GA_FORM_SUCCESSFULLY_FINISHED_EFFECT: null,
        GA_FORM_START_EFFECT: null,
        GA_FORM_ERROR_EFFECT: null,
        LINKEDIN_RECEIVE_MESSAGE: null,
        LINKEDIN_SET_USER_DATA: null,
        SET_URL_PARAM_EFFECT: null,
        VALIDATE_GUEST_INFORMATION: null,
        SESSION_REGISTRATION_FORM_SUBMISSION: null,
    },
    '@effect/formRenderer',
);
